var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRoadblockChrome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 52,
  height: 52,
  viewBox: "0 0 52 52",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m4.416 11 10.692 18.93.078-.046c1.628 4.39 5.758 7.51 10.599 7.51 1.882 0 3.656-.473 5.215-1.308L22.208 52C9.666 50.248 0 39.194 0 25.816 0 20.326 1.629 15.226 4.416 11m45.641 5A25.9 25.9 0 0 1 52 25.87C52 40.303 40.246 52 25.748 52q-.882-.001-1.748-.059l10.688-18.724a11.45 11.45 0 0 0 2.727-7.43c0-4.13-2.184-7.75-5.464-9.787ZM26 16c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10m-.44-16C35.843 0 44.74 6.287 49 15.023h-.082c-1.436.01-21.33.135-23.15.143h-.126c-6.259 0-11.349 4.548-11.518 10.834L5 10.118C9.782 3.958 17.214 0 25.56 0"
})));
export default SvgRoadblockChrome;